import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "rotate(90 10.5 5.5)",
		children: [/* @__PURE__ */ _jsx("polygon", { points: "0 0 24 0 24 24 0 24" }), /* @__PURE__ */ _jsx("polygon", {
			fill: "currentColor",
			fillRule: "nonzero",
			points: "12 10.828 7.05 15.778 5.636 14.364 12 8 18.364 14.364 16.95 15.778"
		})]
	})
});
export default SvgArrowRight;
